var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.941406C12.4344 0.941406 9.43763 1.82449 6.88867 3.47899C4.33971 5.13349 2.35303 7.4851 1.17987 10.2364C0.00671597 12.9878 -0.300236 16.0152 0.297835 18.936C0.895906 21.8568 2.37214 24.5398 4.53985 26.6455C6.70756 28.7513 9.4694 30.1854 12.4761 30.7664C15.4828 31.3473 18.5993 31.0492 21.4316 29.9095C24.2639 28.7699 26.6846 26.84 28.3878 24.3638C30.0909 21.8877 31 18.9766 31 15.9985C30.9954 12.0065 29.3609 8.1793 26.455 5.35651C23.5492 2.53372 19.6094 0.945904 15.5 0.941406ZM15.5 28.9047C11.9764 28.9047 8.59714 27.5449 6.10559 25.1245C3.61403 22.7042 2.21429 19.4215 2.21429 15.9985C2.21429 12.5756 3.61403 9.29291 6.10559 6.87254C8.59714 4.45217 11.9764 3.09243 15.5 3.09243V15.9985L24.8899 25.1204C23.6585 26.3208 22.195 27.2731 20.5836 27.9226C18.9722 28.572 17.2446 28.9057 15.5 28.9047Z",
    fill: "#399E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealing);
export default __webpack_public_path__ + "static/media/Dealing.a10811e6313ded60d19bbcbd3ed14a3a.svg";
export { ForwardRef as ReactComponent };